import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import useService from '../../utils/useService';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { executeBulkReply } = useService();

	const handleFormSubmit = async (submittedData: any) => {
		try {
			await executeBulkReply(submittedData);
			showAlert('CSV uploaded');
			setShowLoader(false);
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error?.response?.data?.error}`, { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
